import _ from 'lodash';
import baseConfig from '../base-config';
import mechanicTypes from '../../mechanic-types';

/**
 * See '/common-entities/workspace/workspaces/base-config.js' for defaults
 */
const workspaceConfig = {
  mechanics: {
    [mechanicTypes.ENTRIES]: {
      isSupported: true,
    },
    [mechanicTypes.REWARDS]: {
      isSupported: true,
    },
    [mechanicTypes.INSIGHTS]: {
      isSupported: true,
    },
    [mechanicTypes.PROMOTIONS]: {
      isSupported: true,
    },
  },
};

export default _.merge({}, baseConfig, workspaceConfig);
